import { useTranslation } from 'i18n';
import { Grid, Page, Section } from 'ui';

import { PopularLinks } from '../components/PopularLinks/PopularLinks';
import { TabNavigation } from '../components/TabNavigation/TabNavigation';

export const GroundControl = () => {
  const { t } = useTranslation('orders');

  return (
    <Page>
      <Page.Title title={t('groundControl.pageTitle')} />
      <Page.Divider />
      <Grid container>
        <Grid size={12}>
          <Section>
            <TabNavigation />
          </Section>
        </Grid>
        <Grid size={12}>
          <Section title={t('groundControl.popularLinks')}>
            <PopularLinks />
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
